// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @utils
const apiURLBuilder = require('core/apiURLBuilder');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const {WIZARD_VERTICAL_VIEW_MODE} = require('constants/index');
const { formatText } = require('core/i18n').i18n;

// @components
const CardGenericConfirmationStep = require('components/contactCenter/cardGenericConfirmationStep/cardGenericConfirmationStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const {
    CIC_CHANNEL
} = require('constants/index');
var _require2 = require('constants/operationTypes'),
CANCEL_POST_PAYMENT_TODAY = _require2.CANCEL_POST_PAYMENT_TODAY,
CANCEL_POST_PAYMENT_HISTORY = _require2.CANCEL_POST_PAYMENT_HISTORY;
const { DATE_FORMAT_API,  } = require('constants/index');
const moment = require('moment');

class CancelPostPaymentWizard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleFinish(){
        const {paymentDetail} = this.props;
        this.props.cancelPostPaymentSuccess(this.props.cardId, paymentDetail);
    }

    handleCancel() {
        this.props.history.push(apiURLBuilder.getURL("cardIdUrl", {cardId: this.props.cardId}));
    }

    buildWizard() {
        const { setVisibleStep, validateStep, immCancelPostPayData, setWillCancel, paymentDetail, immCard } = this.props;
        const operativeName = formatText('cancelPostPayment-operativeName');
        const immSteps = immCancelPostPayData.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immCancelPostPayData.get('visibleStep');
        const nextBtnLabel = 'sendPinByMailStep3-confirmBtn';
        const pan = immCard.get('number').replace(/\s/g,'');
        const movementDate = paymentDetail.get('fecanota');
        const movDia = paymentDetail.get('liamovto');

        const defaultDate = moment().format(DATE_FORMAT_API);
        let operationType;
        if (movementDate == defaultDate) {
            operationType = CANCEL_POST_PAYMENT_TODAY;
        } else {
            operationType = CANCEL_POST_PAYMENT_HISTORY;
        }

        const operationParams =  {
            "channel": CIC_CHANNEL,
            "pan": pan,
            "optional1": movDia,
            "optional2": moment(movementDate, DATE_FORMAT_API).format('DD-MM-YYYY')
        };

        const actions = {
            setVisibleStep,
            validateStep,
            finish: this.handleFinish,
            setWillCancel : setWillCancel,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                fullWidth={false}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                viewMode={WIZARD_VERTICAL_VIEW_MODE}

                >
                <WizardStep
                    cancelButton={true}
                    isLoading={false}
                    position="first"
                    nextBtnModifier="primary"
                    >
                    <CardGenericConfirmationStep
                        operativeName={operativeName}
                        immCard={immCard}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    immFinalButton={nextBtnLabel}
                    omitPreviousButton={true}
                    position="last"
                    nextBtnModifier="primary"
                    >
                    <VerifyOtpStep
                        operationType={operationType}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    render() {
        const content = this.buildWizard();

        return (
            <div className="cancel-post-payment-view" id="printable-wizard">
                {content}
            </div>
        );
    }
}

CancelPostPaymentWizard.propTypes = {
    history: PropTypes.object.isRequired,
    immCancelPostPayData: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    cancelPostPaymentSuccess:PropTypes.func,
    immCard: PropTypes.object.isRequired,
    cardId: PropTypes.string.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    paymentDetail:PropTypes.object
};

module.exports = withRouter(CancelPostPaymentWizard);
